export const subModuleMappings: Record<string, string> = {
    "chart-of-accounts": "chart-of-account",
    "tax-template": "tax-templates",
    "bank": "banks",
    "bank-account": "bank-accounts",
    "journal-entry": "journal-entries",
    "payment": "payment-entries",
    "collection": "payment-entries",
    "debit-note": "debit-notes",
    "credit-note": "credit-notes",
    "customer-management": "parties",
    "vendor-management": "parties",
    "bill-of-material": "bills-of-materials",
    "payment-request": "sales-invoices/request-payment",
    "commission-plan": "commission-plans",
    "target": "commission-targets",
    "assignment": "commission-assignment",
    "assets-management": "assets",
    "asset-transfer":"assets-transfer",
    "authorize-commission": "commission/authorize",
    "reconciliation": "reconciliaton",
    "expense-report": "expense-reimbursement",
    "items":"inventory-items",
    "discounted-item":"discount-items",
    "location":"warehouse-location",
    "stock-transfer":"stock-transfers",
    "scrap":"stock-transfers",
    "bins":"bin",
    "item-category": "category-items",
    "operation-blocks":"operation-block",
    "work-centers":"work-centre",
    "work-center-categories":"work-centre-categories",
    "equipment-failure":"equipments/failures",
    "manage-operations":"job-cards/operations",
    "unbuild-order":"unbuild-orders",
    "build-order":"build-orders",
    "shippment-rules":"shipping-rules",
    "promotions":"promotion",
    "customer-segments":"customer-segment",
    "requests": "purchase-requests",
    "request-for-quote": "rfq",
    "purchase-order": "purchase-orders",
    "vendor-returns": "vra",
    "delivery-order": "delivery-orders",
    "landed-cost": "landing-cost",
    "billing-cycle":"rental-billing-cycles",
    "terms-and-conditions":"rental-terms-conditions",
    "leads":"rental-lead",
    'agreements': "rental-agreements",
    "department-master": "departments",
    "employee-master": "employee",
    "accruals-and-benefit": "accrual-master"
  };
  
  
export const specificFilters: Record<string, string> = {
    "payment": "payment_type.eq=Send",
    "collection": "payment_type.eq=Receive",
    "customer-management": "type.eq=Customer",
    "vendor-management": "type.eq=Vendor",
    "scrap":"operation_type.in=[Scrap]",
    "items":"is_variant.eq=false|self_variant.eq=true",
    "item": 'is_variant.eq=false|self_variant.eq=true',
    'agreements':"is_rental.eq=1",
    "opportunity": "is_rental.eq=0",
    "rental-opportunity": "is_rental.eq=1",
    
  };